import {useEffect, useState} from "react";
import axiosInstance from "../API/Axios/AxiosConfig";
import URLS from "../API/Axios/URLS";
import {toast} from "react-toastify";
import {LIKED_COMMENT_ACTIONS} from "../redux/Reducers/LikedCommentReducer";

export default function useVocabFavorite() {
    const [favorite, setFavorite] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getFavorite = () => {
        if (isLoading) return
        setIsLoading(true)
        axiosInstance.get(URLS.getOrAddOrFav).then((res) => {
            setFavorite(res.data?.data)
        }).catch((err) => {
        }).finally(() => {
            setIsLoading(false)
        })
    }


    const addRemoveFavorite = (id) => {
        toast.promise(axiosInstance.post(URLS.getOrAddOrFav, {wordId: id}), {
            pending: "Loading...",
            success: favorite.includes(id) ? "remove from favorite" : "added to favorite",
            error: "Something went wrong",
        }, {
            hideProgressBar: false,
            toastId: "add-remove-fav",
        }).then((res) => {
            setFavorite(res.data?.data?.likedWordId)
        })
    }

    function isFavorite(id) {
        return favorite.includes(id)
    }

    useEffect(() => {
        getFavorite()
    }, [])
    const actions = {
        getFavorite,
        addRemoveFavorite,
        isFavorite
    }

    return [favorite, isLoading, actions]

}